export const GuideHeader = ({ mod, playing }) => (
  <div className="flex flex-col items-center text-center mb-10">
    <span className="relative block w-24 h-24 md:w-28 md:h-28 mb-6">
      {playing && <span className="absolute inset-0 rounded-full border border-[#F59E0B]/60 animate-ping" />}
      <img src="/author/avatar.jpg" alt="Rich Culmer, your guide" className={`relative w-full h-full rounded-full object-cover border-2 ${playing ? "border-[#F59E0B]" : "border-[#E7DFD5]"}`} />
    </span>
    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309] mb-3">
      Rich · {playing ? "speaking" : "your guide"} · Module {mod.n}
    </div>
    {playing && (
      <span className="flex items-end gap-[3px] h-4 mb-4" data-testid="cinematic-eq">
        {[0, 1, 2, 3, 4].map((i) => (
          <span key={i} className="w-[3px] bg-[#F59E0B] rounded-full tacc-eq-bar" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </span>
    )}
    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">{mod.title}</h1>
    <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] mt-3">{mod.focus} · {mod.duration}</p>
  </div>
);
